import React, { useState } from 'react'
import notification from '../../../assets/images/dashboard/header/bell.svg'
import arrow from '../../../assets/images/dashboard/header/doenArrow.svg'
import search from "../../../assets/images/dashboard/body/Search.svg"
import img from "../../../assets/images/img.svg"
import FindCategory from '../../ui/FindCategory'

const OrganizationCoupons = () => {


    const [filterCategoryModal, setFilterCategoryModal] = useState(false);
    const toggleFilterCategoryModal = () => setFilterCategoryModal(!filterCategoryModal);
    const closeFilterCategoryModalModal = () => {
        setFilterCategoryModal(false);
    };

    const couponsData = [
        {
            status: 'Available',
            name: 'Coupon Name',
            description: '2 Tickets to see Wicked on Broadway',
            expiresIn: '4 Days',
        },
        {
            status: 'In Progress',
            name: 'Coupon Name',
            description: 'New Nikes',
            expiresIn: '12 Days',
        },
        {
            status: 'Expired',
            name: 'Coupon Name',
            description: 'Sip and Shop Experience',
            expiresIn: '3 Days',
        },
        {
            status: 'Available',
            name: 'Coupon Name',
            description: '$10 to Good & Gather Coffee Shop',
            expiresIn: '2 Days',
        },
        {
            status: 'Used',
            name: 'Coupon Name',
            description: '$10 to Good & Gather Coffee Shop',
            expiresIn: '2 Days',
        },
        {
            status: 'Available',
            name: 'Coupon Name',
            description: '2 Tickets to see Wicked on Broadway',
            expiresIn: '4 Days',
        },
        {
            status: 'In Progress',
            name: 'Coupon Name',
            description: 'New Nikes',
            expiresIn: '12 Days',
        },
        {
            status: 'Expired',
            name: 'Coupon Name',
            description: 'Sip and Shop Experience',
            expiresIn: '3 Days',
        },
        {
            status: 'Available',
            name: 'Coupon Name',
            description: '$10 to Good & Gather Coffee Shop',
            expiresIn: '2 Days',
        },
        {
            status: 'Used',
            name: 'Coupon Name',
            description: '$10 to Good & Gather Coffee Shop',
            expiresIn: '2 Days',
        },
    ];

    return (
        <div className=''>
            <div className='dashboard_header relative '>
                <div className='hidden lg:flex py-4 lg:pr-10 bg_header border-b-2 border-[#362269]'>
                    <div className='relative hidden lg:flex items-center pl-8'>
                        <input type="search" placeholder='Search' className='min-w-[625px] h-8 border-0 rounded-lg' />
                        <img src={search} alt="search" className='absolute right-[15px] top-[10px] ' />
                    </div>

                    <div className='flex ml-auto items-center'>
                        <span className='w-8 h-8  rounded-full'><img src={img} alt="img" /></span>

                        <div className='flex items-center'>
                            <p className='pl-3 font-bold'>Organization</p>
                        </div>

                        <img src={notification} alt="notification" className='pl-4 text-black' />
                    </div>

                </div>
                <div className='circle_design'></div>


                <div className="my-16 mx-4 lg:mx-auto lg:w-[85%] border border_dark bg-[#F6F2EF] rounded-lg overflow-hidden">
                    <div className="flex justify-between items-center border-b-2 border_dark p-3 rounded-t-lg">
                        <h2 className="text-lg font-bold text-purple-900">Coupon management</h2>
                        <button
                            onClick={toggleFilterCategoryModal}
                            className="border flex justify-center items-center border-gray-300 bg-[#C6AFFF] w-[150px] h-[40px] text-[12px] rounded-xl"
                        >
                            Filter by Category
                            <img src={arrow} alt="arrow" className="w-[10px] h-auto p-[1px] ml-1" />
                        </button>

                        {filterCategoryModal && (
                            <div
                                id="category-modal"
                                tabIndex="-1"
                                aria-hidden={!filterCategoryModal}
                                className="fixed inset-0 z-50 flex justify-center items-center bg-gray-900 bg-opacity-50"
                                onClick={closeFilterCategoryModalModal}
                            >
                                <div
                                    className="relative w-full max-w-xl max-h-full rounded-lg"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <FindCategory onLogin={closeFilterCategoryModalModal} />
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="overflow-x-auto">
                        <table className="font_ovo min-w-full border-2 border_dark rounded-lg whitespace-nowrap">
                            <thead className="text-[#362269] font-bold font_family">
                                <tr>
                                    <th className="text-left border-2 border_dark md:px-4 md:py-2"></th>
                                    <th className="text-left border-2 border_dark md:px-4 md:py-2 sm:text-base text-sm">STATUS</th>
                                    <th className="text-left border-2 border_dark md:px-4 md:py-2 sm:text-base text-sm">COUPON NAME</th>
                                    <th className="text-left border-2 border_dark md:px-4 md:py-2 sm:text-base text-sm">DESCRIPTION</th>
                                    <th className="text-left border-2 border_dark md:px-4 md:py-2 sm:text-base text-sm">Expires in</th>
                                </tr>
                            </thead>
                            <tbody>
                                {couponsData.map((coupon, index) => (
                                    <tr key={index} className="border-2 border_dark">
                                        {/* Status column with conditional coloring */}
                                        <td
                                            className={`px-4 py-2 border-2 border_dark font-bold text-white ${coupon.status === 'Expired'
                                                    ? 'bg-[#FF4161]'
                                                    : coupon.status === 'In Progress'
                                                        ? 'bg-[#FF889C]'
                                                        : coupon.status === 'Used'
                                                            ? 'bg-[#362269]'
                                                            : 'bg-green-300'
                                                }`}
                                        ></td>

                                        <td className="p-2 md:px-4 md:py-2 border-2 border_dark sm:text-base text-sm text-purple-900 hover:underline cursor-pointer">
                                            {coupon.status}
                                        </td>

                                        <td className="p-2 md:px-4 md:py-2 border-2 border_dark sm:text-base text-sm text-purple-900 hover:underline cursor-pointer">
                                            {coupon.name}
                                        </td>

                                        <td className="p-2 md:px-4 md:py-2 border-2 border_dark sm:text-base text-sm text-gray-700">{coupon.description}</td>

                                        <td className={`p-2 md:px-4 md:py-2 border-2 border_dark sm:text-base text-sm ${coupon.status === 'Expired' ? 'text-red-500' : ''}`}>
                                            {coupon.expiresIn}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="flex justify-center items-center border_dark border-t-2 rounded-b-lg">
                        <button className="bg-[#C6AFFF] font-bold text-black w-full h-10 flex items-center justify-center text-2xl">
                            +
                        </button>
                    </div>
                </div>





            </div>
        </div>
    )
}

export default OrganizationCoupons